
export const Maximize = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24'
    fill='none' stroke='#111111' strokeWidth='2' strokeLinecap='round'
    strokeLinejoin='arcs'>
    <path d='M15 3h6v6M14 10l6.1-6.1M9 21H3v-6M10 14l-6.1 6.1'/>
  </svg>
);
